<template>
  <el-dialog
    class="comp-container"
    :visible.sync="visible"
    width="30%"
    top="30vh"
    custom-class="comfirm-remove-dialog"
    :append-to-body="true"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
  >
    <div class="title">是否重新录制</div>
    <div class="tips">选择重新录制，原录制内容将被删除</div>
    <div class="footer">
      <el-button @click="handleCancel"> 取消 </el-button>
      <el-button type="primary" @click="handleConfirm" v-preventReClick>
        确定重录
      </el-button>
    </div>
  </el-dialog>
</template>

<script>
import { mapState } from "vuex";
import { reRecord } from "@saas/service-api/src/live-sdk";
export default {
  data() {
    return {
      visible: false,
      timer: null,
    };
  },
  computed: {
    ...mapState("live", ["roomInfo"]),
  },
  methods: {
    handleCancel() {
      this.visible = false;
    },
    handleConfirm() {
      this.visible = true;
      reRecord({
        room_id: this.roomInfo.id,
      })
        .then((res) => {
          console.log("rerecord___", res);

          if (res.code === 1) {
            this.$darkMessage.success("已开始重新录制");
            this.visible = false;
          } else {
            this.$darkMessage.error(res.message);
          }
        })
        .catch((err) => {
          console.error(err);
        });
    },
    open() {
      this.visible = true;
    },
  },
};
</script>

<style lang="scss" scoped>
.comp-container ::v-deep {
  .comfirm-remove-dialog {
    width: 327px !important;
    background: #18181b;
    box-shadow: 0px 1px 2px 0px rgba(0, 0, 0, 0.06),
      0px 1px 3px 0px rgba(0, 0, 0, 0.1);
    border-radius: 12px 12px 12px 12px;
    border: 1px solid rgba(229, 231, 235, 0.04);
    padding: 16px;

    .el-dialog__header {
      display: none;
    }
    .el-dialog__body {
      padding: 0;
      font-size: 14px;
      color: #f7f8fa;

      text-align: center;
      .title {
        width: 100%;
        font-weight: 600;
        font-size: 18px;
        color: #ecedee;
        line-height: 28px;
        text-align: left;
      }
      .tips {
        max-width: 300px;
        height: 48px;
        display: flex;
        justify-content: left;
        align-items: center;
      }
      .el-checkbox {
        margin-top: 8px;
        .el-checkbox__input.is-checked {
          .el-checkbox__inner {
            background: #165dff;
            border-color: #165dff;
          }
        }
        .el-checkbox__inner {
          border-color: #165dff !important;
          &:hover {
            border-color: #165dff;
          }
        }
        .el-checkbox__label {
          color: #a1a1aa;
        }
      }
      .footer {
        margin-top: 16px;
        display: flex;
        justify-content: space-between;
        align-items: center;
        .el-button {
          flex: 1;
          background: #165dff;
          border-radius: 12px 12px 12px 12px;
          border: none;
          font-weight: 500;
          font-size: 14px;
          color: #ecedee;
          &.el-button--primary {
            background: #165dff;
            &:hover {
              background: #165dff !important;
            }
            &:focus {
              background: #165dff !important;
            }
          }
          &.el-button--default {
            background: #3f3f46;
          }
        }
      }
    }
    .el-dialog__footer {
      display: none;
    }
  }
}
</style>
